import { socketService } from "@/utils/socket";
import type { WSEventPayload } from "@shared/types";

/**
 * Lightweight composable wrapper around the shared SocketService.
 * Exposes connect/disconnect and typed emit/on helpers.
 */
export const useWebSocket = () => {
  const connect = (): void => socketService.connect();
  const disconnect = (): void => socketService.disconnect();

  const emit = <E extends keyof WSEventPayload>(
    event: E,
    payload: WSEventPayload[E],
  ): void => socketService.emit(event, payload);

  const on = <E extends keyof WSEventPayload>(
    event: E,
    callback: (payload: WSEventPayload[E]) => void,
  ): void => socketService.on(event, callback);

  const socket = socketService.getSocket();
  const isConnected = (): boolean => socketService.isConnected;

  return {
    socket,
    connect,
    disconnect,
    emit,
    on,
    isConnected,
  };
};
